import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';

import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';

import { CaoOpportunityWidgetComponent } from './cao-opportunity.widget.component';
import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    TeamManagementEffectiveness,
    TeamManagementEffectivenessItem,
} from './team-management-effectiveness.widget.model';

@Component({
    selector: 'cmps-widget-team-management-effectiveness',
    templateUrl: './team-management-effectiveness.widget.component.html',
})
export class TeamManagementEffectivenessWidgetComponent
    implements OnInit, OnDestroy
{
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: TeamManagementEffectiveness;
    private _modal: NgbModalRef;

    constructor(
        private readonly _modalService: NgbModal,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _service: LegacyWidgetService,
    ) {}

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .teamManagementEffectiveness()
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    showDetails(item: TeamManagementEffectivenessItem): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            size: 'lg',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: CaoOpportunityWidgetComponent,
            options: {
                userId: item.userId,
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
